<ls-breadcrumb currentLocation="Components"> </ls-breadcrumb>
<ls-page>
  <div class="c-section__wrapper">
    <h2>Cirrus</h2>

    <form #f="ngForm" class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Dropdowns</h5>
        <p class="c-section__description">Output:</p>
        <pre>
          {{ f.value | json }}
        </pre>
        <div>Form is valid: {{ f.valid }}</div>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <label>Multi-Select</label>
          <ls-multi-select
            name="multiSelect1"
            [items]="multiSelectItems"
            placeholder="Select Location"
            ngModel
          ></ls-multi-select>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Multi-Select Dropdown with min:1, max:3</label>
          <ls-multi-select
            name="multiSelect2"
            [items]="multiSelectItems"
            placeholder="Select Location"
            ngModel
            min="1"
            max="3"
          ></ls-multi-select>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Multi-Select Dropdown with Search</label>
          <ls-multi-select
            [multiSelectSearch]="true"
            name="multiSelect3"
            [items]="multiSelectItems"
            placeholder="Type/select Location"
            ngModel
          ></ls-multi-select>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Single-Select Dropdown</label>
          <ls-single-select
            name="singleSelect1"
            [items]="singleSelectItems"
            placeholder="Select Location"
            ngModel
          ></ls-single-select>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Single-Tooltip Dropdown</label>
          <ls-single-tooltip-select
            name="singleTooltipSelect1"
            [items]="singleSelectItems"
            placeholder="Select Location"
            ngModel
          ></ls-single-tooltip-select>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Multi checkbox component</label>
          <ls-multi-checkbox
            title="Multiple checkboxes"
            name="multiCheck"
            [options]="singleSelectItems"
            description="Select something"
            ngModel
          >
          </ls-multi-checkbox>
        </div>
      </div>
    </form>

    <form
      #f2="ngForm"
      (ngSubmit)="showPopup(f2.value.type, f2.value.title, f2.value.message)"
      class="o-layout__block c-section"
    >
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Modals</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <label>Select a modal you want to show</label>
          <div class="o-layout__row">
            <label class="o-radio">
              <input
                type="radio"
                ngModel
                name="type"
                value="message"
                class="o-radio__input"
              />
              <div class="o-radio__label">Message Modal</div>
            </label>
            <label class="o-radio">
              <input
                type="radio"
                ngModel
                name="type"
                value="yesno"
                class="o-radio__input"
              />
              <div class="o-radio__label">Yes/No Modal</div>
            </label>
          </div>
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Title</label> <input type="text" ngModel name="title" />
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Message</label> <input type="text" ngModel name="message" />
        </div>
        <div class="c-form__item u-layout-auto">
          <button
            type="submit"
            class="o-button o-button--success o-button--large"
          >
            Show Modal
          </button>
        </div>
      </div>
    </form>

    <form
      #f3="ngForm"
      (ngSubmit)="showMultiplePopups(f3.value.quantity)"
      class="o-layout__block c-section"
    >
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Multiple Modals</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <label>Select a number of modals you want to show</label>
          <input type="number" ngModel name="quantity" value="5" />
        </div>
        <div class="c-form__item u-layout-auto">
          <button
            type="submit"
            class="o-button o-button--success o-button--large"
          >
            Show Modals
          </button>
        </div>
      </div>
    </form>

    <form class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Pagination</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <label>Enter the total number of pages</label>
          <input
            type="number"
            [(ngModel)]="pagination.totalPages"
            name="totalPages"
          />
        </div>
        <div class="c-form__item u-layout-auto">
          <label>Enter a number of pages you want to show</label>
          <input
            type="number"
            [(ngModel)]="pagination.showPages"
            name="showPages"
          />
        </div>
        <div class="c-form__item u-layout-auto">
          <label class="o-checkbox u-margin-0">
            <input
              type="checkbox"
              [(ngModel)]="pagination.showFirstLast"
              name="showFirstLast"
              class="o-checkbox__input"
            />
            <span class="o-checkbox__indicator">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>
            <div class="o-checkbox__label">Show the first and last button</div>
          </label>
        </div>
        <div class="c-form__item u-layout-auto">
          <label class="o-checkbox u-margin-0">
            <input
              type="checkbox"
              [(ngModel)]="pagination.showNextPrevious"
              name="showNextPrevious"
              class="o-checkbox__input"
            />
            <span class="o-checkbox__indicator">
              <i class="fa fa-check" aria-hidden="true"></i>
            </span>
            <div class="o-checkbox__label">
              Show the next and previous button
            </div>
          </label>
        </div>
        <div class="c-form__item u-layout-auto">
          <ls-pagination
            [totalPages]="pagination.totalPages"
            [showPages]="pagination.showPages"
            [showFirstLast]="pagination.showFirstLast"
            [showNextPrevious]="pagination.showNextPrevious"
          ></ls-pagination>
        </div>
      </div>
    </form>

    <form class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Datepicker</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <ls-datepicker
            [range]="daterange"
            (dateChanged)="dateChanged($event)"
          ></ls-datepicker>
        </div>
      </div>
    </form>

    <form class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Loader Button</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <button
            loader-button
            [state]="currentState"
            (click)="nextState(currentState)"
            class="o-button o-button--success o-button--medium"
          >
            Some Text
          </button>
        </div>
      </div>
    </form>

    <form class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Switch Table</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="c-form__item u-layout-auto">
          <ls-switch-table
            [titles]="switchTableTitles"
            [items]="switchTableItems"
            [legendItems]="switchTableLegendItems"
          ></ls-switch-table>
        </div>
      </div>
    </form>

    <div class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Boolean Component</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          When set true:
          <ls-boolean [state]="true"></ls-boolean>
          <br />
          When set false:
          <ls-boolean></ls-boolean>
        </div>
      </div>
    </div>

    <div class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Action buttons</h5>
        <p class="c-section__description">
          Action Clicked: {{ actionClicked | json }}
        </p>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <form #actionButtonForm="ngForm">
          <label>Select a state for the action button</label>
          <label class="o-radio u-margin-0">
            <input type="radio" name="action-status" value="default" ngModel />
            <span class="o-checkbox__label">Default</span>
          </label>
          <label class="o-radio u-margin-0">
            <input type="radio" name="action-status" value="disabled" ngModel />
            <span class="o-checkbox__label">Disabled</span>
          </label>
          <label class="o-radio u-margin-0">
            <input
              type="radio"
              name="action-status"
              value="highlight"
              ngModel
            />
            <span class="o-checkbox__label">Highlight</span>
          </label>

          <ls-action-button
            (action)="lsActionButtonClicked($event)"
            [icon]="actionButtonIcons.STAR"
            [highlight]="
              actionButtonForm.value['action-status'] === 'highlight'
            "
            [disabled]="actionButtonForm.value['action-status'] === 'disabled'"
            [title]="'Star'"
          >
          </ls-action-button>
          <ls-action-button
            (action)="lsActionButtonClicked($event)"
            [icon]="actionButtonIcons.PENCIL"
            [highlight]="
              actionButtonForm.value['action-status'] === 'highlight'
            "
            [disabled]="actionButtonForm.value['action-status'] === 'disabled'"
            [title]="'Edit'"
          >
          </ls-action-button>
          <ls-action-button
            (action)="lsActionButtonClicked($event)"
            [icon]="actionButtonIcons.CLIPBOARD"
            [highlight]="
              actionButtonForm.value['action-status'] === 'highlight'
            "
            [disabled]="actionButtonForm.value['action-status'] === 'disabled'"
            [title]="'Copy'"
          >
          </ls-action-button>
          <ls-action-button
            (action)="lsActionButtonClicked($event)"
            [icon]="actionButtonIcons.TRASH"
            [highlight]="
              actionButtonForm.value['action-status'] === 'highlight'
            "
            [disabled]="actionButtonForm.value['action-status'] === 'disabled'"
            [title]="'Delete'"
          >
          </ls-action-button>
        </form>
      </div>
    </div>

    <div class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Text area Component</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          <ls-text-area
            [label]="textAreaLabel"
            [text]="textAreaText"
            [placeHolder]="textAreaPlaceHolder"
            [maxlength]="textAreaMax"
            required="true"
          ></ls-text-area>
        </div>
      </div>
    </div>

    <form #f4="ngForm" class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">IP Address Template driven forms</h5>
        <p class="c-section__description">Output:</p>
        <pre>
          {{ f4.value | json }}
        </pre>
        <div>Form is valid: {{ f4.valid }}</div>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          <ls-ip-address
            [label]="'IP Address not required'"
            [placeHolder]="'192.168.0.108'"
            [required]="false"
            name="ipAddressNotRequired"
            ngModel
          ></ls-ip-address>
        </div>
      </div>
    </form>

    <form [formGroup]="reactiveIpForm" class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">IP Address Reactive forms</h5>
        <p class="c-section__description">Output:</p>
        <pre>
          {{ reactiveIpForm.value | json }}
        </pre>
        <div>Form is valid: {{ reactiveIpForm.valid }}</div>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          <ls-ip-address
            [label]="'IP Address required'"
            [placeHolder]="'123.1.0.10'"
            [required]="true"
            formControlName="ipAddressRequired"
          ></ls-ip-address>
        </div>
      </div>
    </form>

    <form #f5="ngForm" class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Input Grid</h5>
        <p class="c-section__description">Output:</p>
        <pre>
          {{ f5.value | json }}
        </pre>
        <div>Form is valid: {{ f5.valid }}</div>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          <ls-input-grid name="inputGrid" ngModel></ls-input-grid>
        </div>
      </div>
    </form>

    <form class="o-layout__block c-section">
      <div class="o-layout__item c-section__left">
        <h5 class="c-section__title">Shift Setting Component</h5>
      </div>
      <div class="o-layout__item c-section__right u-layout-grow">
        <div class="u-layout-auto">
          <ls-shift-settings></ls-shift-settings>
        </div>
      </div>
    </form>
  </div>
</ls-page>
